import React from 'react';
import {
  Box,
  Checkbox,
  Chip,
  FormControl,
  FormHelperText,
  InputLabel,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
} from '@mui/material';
import { useFormContext } from 'react-hook-form';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  disableAutoFocusItem: true,
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
    },
    onMouseDown: (event) => event.stopPropagation(),
  },
  MenuListProps: {
    onMouseDown: (event) => event.stopPropagation(),
  },
};

const MultiSelectField = (props) => {
  const { name = '', label, options, defaultValue = [], disabled } = props;

  const {
    register,
    watch,
    formState: { errors },
  } = useFormContext();

  const values = watch(name);

  return (
    <FormControl sx={{ mt: 2, mb: 1, width: '100%' }}>
      <InputLabel id={`multiple-checkbox-label-${name}`} error={!!errors?.[name]}>
        {label}
      </InputLabel>
      <Select
        labelId={`multiple-checkbox-label-${name}`}
        id={`multiple-checkbox-${name}`}
        multiple
        fullWidth
        disabled={disabled}
        defaultValue={defaultValue}
        {...register(name)}
        input={<OutlinedInput label={label} fullWidth />}
        renderValue={(selected) => (
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
            {selected?.map((value) => (
              <Chip key={value} label={value} />
            ))}
          </Box>
        )}
        MenuProps={MenuProps}
        variant='outlined'
        error={!!errors?.[name]}
        value={values || []}
      >
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            <Checkbox checked={values?.includes(option.value)} />
            <ListItemText primary={option.label} />
          </MenuItem>
        ))}
      </Select>
      {errors?.[name] && <FormHelperText error>{errors[name]?.message}</FormHelperText>}
    </FormControl>
  );
};

export default MultiSelectField;
